<!-- <h2 mat-dialog-title style="font-weight: bold;">Are You Sure to Delete Adaptive UI?</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onConfirm()">OK</button>
</mat-dialog-actions> -->

<h2 mat-dialog-title style="font-size: 1.5rem; font-weight: bold;">
   Delete Adaptive UI?
</h2>
<mat-dialog-content style="font-size: 1rem;">
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onConfirm()">OK</button>
</mat-dialog-actions>

 